var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 453.458,
    height: 328.305,
    viewBox: "0 0 453.458 328.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_social_ideas_e8rj_edited",
    transform: "translate(-0.023 -0.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M81.772,300.862S56.218,250.8,67.45,208.31a85.168,85.168,0,0,0-3.091-53.764A147.087,147.087,0,0,0,52.3,131.3",
    transform: "translate(-29.519 -74.112)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M37.509,57.462c1.219,6.53-7.009,27.557-7.009,27.557S15.22,68.388,14,61.9a11.966,11.966,0,0,1,23.508-4.44Z",
    transform: "translate(-7.806 -27.09)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M98.465,122.452c-2.525,6.095-20.852,19.285-20.852,19.285s-3.787-22.245-1.306-28.384a11.956,11.956,0,0,1,22.2,8.881.326.326,0,0,1-.044.218Z",
    transform: "translate(-42.599 -59.735)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M116.931,257.639c-5.268,4.005-27.731,6.138-27.731,6.138s7.967-21.157,13.191-25.162a11.972,11.972,0,0,1,14.54,19.024Z",
    transform: "translate(-50.355 -133.322)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M113.194,370.811C108.71,375.643,86.9,381.564,86.9,381.564s4.266-22.2,8.75-27.034a11.968,11.968,0,0,1,17.544,16.281Z",
    transform: "translate(-49.057 -198.042)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M17.352,173.353c5.485,3.657,28.079,4.266,28.079,4.266s-9.36-20.548-14.845-24.2a11.965,11.965,0,0,0-13.234,19.938Z",
    transform: "translate(-6.761 -85.474)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M8.5,301.732c6.356,1.828,28.079-4.353,28.079-4.353s-15.062-16.8-21.418-18.632A11.967,11.967,0,0,0,8.5,301.732Z",
    transform: "translate(0 -157.129)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M23.332,429.854c5.964,2.873,28.384.479,28.384.479S39.7,411.222,33.736,408.348a11.945,11.945,0,1,0-10.4,21.505Z",
    transform: "translate(-9.344 -229.877)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M37.509,57.462c1.219,6.53-7.009,27.557-7.009,27.557S15.22,68.388,14,61.9a11.966,11.966,0,0,1,23.508-4.44Z",
    transform: "translate(-7.806 -27.09)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M98.465,122.452c-2.525,6.095-20.852,19.285-20.852,19.285s-3.787-22.245-1.306-28.384a11.956,11.956,0,0,1,22.2,8.881.326.326,0,0,1-.044.218Z",
    transform: "translate(-42.599 -59.735)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M116.931,257.639c-5.268,4.005-27.731,6.138-27.731,6.138s7.967-21.157,13.191-25.162a11.972,11.972,0,0,1,14.54,19.024Z",
    transform: "translate(-50.355 -133.322)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M113.194,370.811C108.71,375.643,86.9,381.564,86.9,381.564s4.266-22.2,8.75-27.034a11.968,11.968,0,0,1,17.544,16.281Z",
    transform: "translate(-49.057 -198.042)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M17.352,173.353c5.485,3.657,28.079,4.266,28.079,4.266s-9.36-20.548-14.845-24.2a11.965,11.965,0,0,0-13.234,19.938Z",
    transform: "translate(-6.761 -85.474)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M8.5,301.732c6.356,1.828,28.079-4.353,28.079-4.353s-15.062-16.8-21.418-18.632A11.967,11.967,0,0,0,8.5,301.732Z",
    transform: "translate(0 -157.129)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M23.332,429.854c5.964,2.873,28.384.479,28.384.479S39.7,411.222,33.736,408.348a11.945,11.945,0,1,0-10.4,21.505Z",
    transform: "translate(-9.344 -229.877)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M898.9,157.836s32.432-50.977,36.35-72.744A280.224,280.224,0,0,1,946.569,43.3",
    transform: "translate(-507.567 -24.421)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M998.861,143.4,978.4,145.141S989.283,163.861,998.861,143.4Z",
    transform: "translate(-552.458 -80.944)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M942.478,117.4l16.194,12.973S937.69,138.731,942.478,117.4Z",
    transform: "translate(-531.773 -66.263)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M1007.458,102.4,989,104.838S1005.281,118.072,1007.458,102.4Z",
    transform: "translate(-558.444 -57.793)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M961,87.4l12.146,8.533S958.386,102.2,961,87.4Z",
    transform: "translate(-542.457 -49.323)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M999.7,65.374s15.106-4.005,17.283-3.134.871,10.448-5.224,10.883S999.7,65.374,999.7,65.374Z",
    transform: "translate(-564.486 -35.046)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M971.636,43.4s9.577,9.142,10.013,11.319-7.836,7.4-12.189,0S971.636,43.4,971.636,43.4Z",
    transform: "translate(-546.565 -24.478)",
    fill: "#fc6681"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 4.353,
    cy: 4.353,
    r: 4.353,
    transform: "translate(438.523 15.44)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 4.353,
    cy: 4.353,
    r: 4.353,
    transform: "translate(430.687 13.263)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M118.873,47.219c-2.22,2.7-3.091,6.53-4.049,10.143-7.749,28.95-26.9,52.24-48.67,68.87-9.229,7.052-20.461,16.5-18.458,29.124,1.088,6.791,5.833,11.754,9.4,17.283,7.444,11.58,9.839,27.3,6.312,41.139-4.049,15.759-15.28,30.473-11.8,46.406,2.133,9.839,9.447,16.8,16.456,22.768q16.39,14.039,33.869,26.294c7.792,5.485,16.107,10.8,25.206,11.493,8.01.609,15.846-2.438,23.464-5.442,6.661-2.612,13.452-5.355,18.806-10.622,3.483-3.439,6.312-7.879,10.187-10.666,9.142-6.617,20.852-2.394,31.344.392a109.245,109.245,0,0,0,74.7-6.835c36.089-16.978,63.6-52.588,98.864-71.656,15.193-8.228,31.692-13.321,45.753-23.9a85.51,85.51,0,0,0,20.112-21.767,94.057,94.057,0,0,0,14.714-57.725c-1.654-20.461-10.97-40.181-25.554-51.717C423.91,48.438,404.189,46.131,386.384,38.73c-18.371-7.662-34.7-20.852-52.893-29.08A108,108,0,0,0,240.2,11.7c-19.808,10.013-39.833,33.346-61.9,35.088C162.58,48.09,131.149,32.331,118.873,47.219Z",
    transform: "translate(-26.787)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M503.656,482.563l-3.7,5.529-14.758,1v-9.926s-3.526-11.536-3.526-12.407-5.877-11.232-5.877-11.232L473.4,453.7l2.438.653C486.416,457.749,500.7,465.5,503.656,482.563Z",
    transform: "translate(-267.301 -256.161)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M473.5,453.7l8.489,15.89v19.59l11.754,3.047-7.4-20.461S477.853,455.441,473.5,453.7Z",
    transform: "translate(-267.357 -256.161)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M473.5,446.346l32.65,59.945,22.637-11.623s-40.486-54.852-45.71-53.981S473.5,446.346,473.5,446.346Z",
    transform: "translate(-267.357 -248.807)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 3.483,
    cy: 3.483,
    r: 3.483,
    transform: "translate(289.291 42.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(279.714 92.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(214.414 43.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(69.623 114.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(170.445 240.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(52.47 160.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(355.026 56.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(256.206 127.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(405.089 104.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 1.741,
    cy: 1.741,
    r: 1.741,
    transform: "translate(291.206 234.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M809.336,248.813h-3.613V245.2h-.609v3.613H801.5v.609h3.613v3.613h.609v-3.613h3.613Z",
    transform: "translate(-452.569 -138.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M398.983,747.811h-1.611V746.2h-.261v1.611H395.5v.261h1.611v1.611h.261v-1.611h1.611Z",
    transform: "translate(-223.313 -421.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M563.983,634.811h-1.611V633.2h-.261v1.611H560.5v.261h1.611v1.611h.261v-1.611h1.611Z",
    transform: "translate(-316.484 -357.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M809.983,404.811h-1.611V403.2h-.261v1.611H806.5v.261h1.611v1.611h.261v-1.611h1.611Z",
    transform: "translate(-455.392 -227.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M641.983,462.811h-1.611V461.2h-.261v1.611H638.5v.261h1.611v1.611h.261v-1.611h1.611Z",
    transform: "translate(-360.528 -260.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M166.983,400.811h-1.611V399.2h-.261v1.611H163.5v.261h1.611v1.611h.261v-1.611h1.611Z",
    transform: "translate(-92.31 -225.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M567.983,165.811h-1.611V164.2h-.261v1.611H564.5v.261h1.611v1.611h.261v-1.611h1.611Z",
    transform: "translate(-318.742 -92.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M244.983,130.811h-1.611V129.2h-.261v1.611H241.5v.261h1.611v1.611h.261v-1.611h1.611Z",
    transform: "translate(-136.354 -72.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M695.683,156.751l-7.183-3,9.577-23.073,7.183,2.96ZM703,129.064a4.5,4.5,0,1,1,5.877-2.438A4.556,4.556,0,0,1,703,129.064Zm19.5,38.788-7.139-2.96,4.658-11.232c1.088-2.656,2.481-6.138-1.175-7.662s-5.485,1.132-6.748,4.136l-4.789,11.449-7.14-2.96,9.577-23.073,6.878,2.83-1.306,3.134.087.044a8.2,8.2,0,0,1,8.315-.914c7.227,3,6.617,8.315,4.005,14.54L722.5,167.852Z",
    transform: "translate(-388.761 -67.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M848.687,312.163l-8.924,9.055c-.043.044-.087.174,0,.218h0l6.269,6.661a1.052,1.052,0,0,1,0,1.524,1.02,1.02,0,0,1-.74.3,1.251,1.251,0,0,1-.784-.3L838.282,323a.194.194,0,0,0-.218,0l-1.524,1.524a6.676,6.676,0,0,1-9.577-.044L825.527,323a.194.194,0,0,0-.218,0l-6.225,6.617a1.052,1.052,0,0,1-1.524,0h0a1.052,1.052,0,0,1,0-1.524h0l6.225-6.617a.2.2,0,0,0,0-.218l-8.924-9.055a.2.2,0,0,0-.218,0,.16.16,0,0,0-.044.131V330.49a2.638,2.638,0,0,0,2.656,2.655h29.167a2.638,2.638,0,0,0,2.656-2.655v-18.11a.187.187,0,0,0-.174-.174C848.774,312.119,848.73,312.119,848.687,312.163Z",
    transform: "translate(-459.966 -176.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M832.938,320.593a4.613,4.613,0,0,0,3.265-1.35l12.973-13.234a2.588,2.588,0,0,0-1.654-.609H818.354a2.587,2.587,0,0,0-1.654.609l12.973,13.234A4.768,4.768,0,0,0,832.938,320.593Z",
    transform: "translate(-461.151 -172.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M683.971,340.3a18.371,18.371,0,1,0,18.371,18.458A18.506,18.506,0,0,0,683.971,340.3Zm3.221,34.261a17.181,17.181,0,0,1-6.443,0v-5.05a3,3,0,0,1,.74-2.22c.218-.261.348-.479,1.349-1.959l-1.654-.261c-4.266-.609-5.921-2.83-6.617-4.571a7.343,7.343,0,0,1,1.132-7.009,1.339,1.339,0,0,0,.261-1.262,6.554,6.554,0,0,1-.043-3.178,10.972,10.972,0,0,1,3.308,1.567,1.777,1.777,0,0,0,.914.218,15.028,15.028,0,0,1,3.918-.566,13.185,13.185,0,0,1,3.613.522,1.576,1.576,0,0,0,1.175-.174,10.448,10.448,0,0,1,3.308-1.567,6.554,6.554,0,0,1-.043,3.178,1.284,1.284,0,0,0,.261,1.262A7.232,7.232,0,0,1,693.5,360.5c-.653,1.741-2.351,3.962-6.617,4.571l-1.654.261a20.8,20.8,0,0,0,1.349,1.959,3,3,0,0,1,.74,2.22v5.05Zm2.177-.609v-4.4a5.189,5.189,0,0,0-.609-2.656,9.118,9.118,0,0,0,6.617-5.616,9.531,9.531,0,0,0-1.219-8.837c.3-1.437.3-3.744-.435-4.832a1.7,1.7,0,0,0-1.437-.74h0a9.26,9.26,0,0,0-4.4,1.785,15.15,15.15,0,0,0-3.918-.522,14.116,14.116,0,0,0-3.874.522,9.3,9.3,0,0,0-4.484-1.785,1.66,1.66,0,0,0-1.35.74c-.784,1.088-.784,3.4-.435,4.832a9.514,9.514,0,0,0-1.219,8.837,9.291,9.291,0,0,0,6.617,5.616,5.007,5.007,0,0,0-.566,1.872,2.843,2.843,0,0,1-1.785.131,2.394,2.394,0,0,1-1.393-1.175,4.378,4.378,0,0,0-3.961-2.438l.174,2.133c.784-.087,1.524.74,1.916,1.393a4.457,4.457,0,0,0,2.612,2.133,4.778,4.778,0,0,0,2.351.044v2.917a16.161,16.161,0,0,1-10.84-15.193,16.238,16.238,0,1,1,21.636,15.237Z",
    transform: "translate(-375.83 -192.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(22.215 128.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M261.5,358.337l2.96,9.011,4.005-3.309-2.09-7.139Z",
    transform: "translate(-169.863 -330.258)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M265.4,372s.435,6.7,1.088,7.139c.609.435,5.442-.435,5.442-.435s1.437.348,7.357-1.262c6.661-1.785-.827-4.44-.827-4.44s-4.832-3.134-6.965-4.615-3.57,1.7-3.57,1.7C268.36,371.351,265.4,372,265.4,372Z",
    transform: "translate(-172.065 -336.524)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M260.559,297.267H184.724V295.7H150.376v1.567H74.237A5.119,5.119,0,0,0,69.1,302.4V406.231a5.119,5.119,0,0,0,5.137,5.137H260.559a5.119,5.119,0,0,0,5.137-5.137h0V302.4a5.119,5.119,0,0,0-5.137-5.137Z",
    transform: "translate(-61.22 -295.7)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 182.883,
    height: 103.174,
    transform: "translate(14.758 10.622)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 1.872,
    cy: 1.872,
    r: 1.872,
    transform: "translate(104.131 4.092)",
    fill: "#e69725"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 181.708,
    height: 103.13,
    transform: "translate(15.062 10.579)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 171.303,
    height: 89.591,
    transform: "translate(20.243 17.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 44.012,
    height: 71.003,
    transform: "translate(35.828 26.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 36.698,
    height: 19.503,
    transform: "translate(87.458 26.947)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 36.698,
    height: 21.027,
    transform: "translate(87.458 51.892)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 36.698,
    height: 19.503,
    transform: "translate(87.458 78.36)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 44.012,
    height: 30.952,
    transform: "translate(131.993 26.947)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 44.012,
    height: 30.952,
    transform: "translate(131.993 66.954)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M260.612,550.667H242.764v-1.306a.281.281,0,0,0-.261-.261h-6.095a.281.281,0,0,0-.261.261h0v1.306h-3.831v-1.306a.281.281,0,0,0-.261-.261H225.96a.281.281,0,0,0-.261.261h0v1.306h-3.787v-1.306a.281.281,0,0,0-.261-.261h-6.095a.281.281,0,0,0-.261.261h0v1.306h-3.831v-1.306a.281.281,0,0,0-.261-.261h-6.095a.281.281,0,0,0-.261.261h0v1.306h-3.831v-1.306a.281.281,0,0,0-.261-.261H194.66a.281.281,0,0,0-.261.261h0v1.306h-3.831v-1.306a.281.281,0,0,0-.261-.261h-6.095a.281.281,0,0,0-.261.261h0v1.306h-3.831v-1.306a.281.281,0,0,0-.261-.261H131.711a.281.281,0,0,0-.261.261h0v1.306h-3.831v-1.306a.281.281,0,0,0-.261-.261h-6.095a.281.281,0,0,0-.261.261v1.306H117.17v-1.306a.281.281,0,0,0-.261-.261h-6.095a.281.281,0,0,0-.261.261h0v1.306h-3.831v-1.306a.281.281,0,0,0-.261-.261h-6.095a.281.281,0,0,0-.261.261h0v1.306H96.275v-1.306a.281.281,0,0,0-.261-.261H90.006a.281.281,0,0,0-.261.261h0v1.306H85.914v-1.306a.281.281,0,0,0-.261-.261H79.558a.281.281,0,0,0-.261.261h0v1.306H75.466v-1.306a.281.281,0,0,0-.261-.261H69.11a.281.281,0,0,0-.261.261h0v1.306H57.095A6.113,6.113,0,0,0,51,556.762h0v2.786a6.113,6.113,0,0,0,6.095,6.095H260.482a6.113,6.113,0,0,0,6.095-6.095v-2.786A5.894,5.894,0,0,0,260.612,550.667Z",
    transform: "translate(-51 -438.787)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(198.655 147.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M517.769,365.761h-.435V345a7.1,7.1,0,0,0-7.1-7.1H464.049a7.1,7.1,0,0,0-7.1,7.1v9.1h-.174a.436.436,0,0,0-.435.435v4.049a.436.436,0,0,0,.435.435h.174v4.049h-.218a.436.436,0,0,0-.435.435h0V371.2a.436.436,0,0,0,.435.435h.218v3h-.174a.436.436,0,0,0-.435.435h0v7.749a.436.436,0,0,0,.435.435h.174v70.35a7.1,7.1,0,0,0,7.1,7.1h46.189a7.1,7.1,0,0,0,7.1-7.1V380.606h.435a.436.436,0,0,0,.435-.435V366.109A.469.469,0,0,0,517.769,365.761Z",
    transform: "translate(-456.3 -337.9)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M521.392,348.072h-7.009a.78.78,0,0,1-.784-.784v-.3a.78.78,0,0,1,.784-.784h7.009a.78.78,0,0,1,.784.784v.3A.754.754,0,0,1,521.392,348.072Z",
    transform: "translate(-488.655 -342.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 0.958,
    cy: 0.958,
    r: 0.958,
    transform: "translate(34.739 3.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M514.548,345.3h-6.922v.827a3.976,3.976,0,0,1-3.962,3.962H481.637a4,4,0,0,1-3.961-3.918h0v-.827h-6.486a4.775,4.775,0,0,0-4.789,4.789h0v106.7a4.775,4.775,0,0,0,4.789,4.789H514.5a4.775,4.775,0,0,0,4.789-4.789h0V350.089a4.738,4.738,0,0,0-4.745-4.789Z",
    transform: "translate(-462.003 -342.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M517.951,569.713H499.406a5.006,5.006,0,1,1,0-10.013h18.545a5.006,5.006,0,1,1,0,10.013Z",
    transform: "translate(-477.814 -463.143)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M519.97,483.783H486.841a1.741,1.741,0,1,1,0-3.483H519.97a1.741,1.741,0,0,1,0,3.483Z",
    transform: "translate(-472.563 -418.309)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M519.97,495.483H486.841a1.741,1.741,0,0,1,0-3.483H519.97a1.741,1.741,0,0,1,0,3.483Z",
    transform: "translate(-472.563 -424.915)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M519.97,507.183H486.841a1.741,1.741,0,0,1,0-3.483H519.97a1.741,1.741,0,0,1,0,3.483Z",
    transform: "translate(-472.563 -431.522)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M519.97,518.883H486.841a1.741,1.741,0,0,1,0-3.483H519.97a1.741,1.741,0,0,1,0,3.483Z",
    transform: "translate(-472.563 -438.129)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M518.826,410.175h-43.49a1.449,1.449,0,0,1-1.437-1.437v-32.3A1.449,1.449,0,0,1,475.337,375h43.49a1.449,1.449,0,0,1,1.437,1.437v32.3A1.421,1.421,0,0,1,518.826,410.175Z",
    transform: "translate(-466.238 -358.849)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(60.293 41.357)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M594.8,433.64v0Z",
    transform: "translate(-594.8 -432.9)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIllustration);
export default __webpack_public_path__ + "static/media/contact_illustration.bbc62303.svg";
export { ForwardRef as ReactComponent };